import { AxiosInstance } from 'axios';

const getCodeServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => ({
  getCode() {
    return GateWayInstance.get<{
      img: string;
      key: string;
    }>(`/validcode`);
  },
});

export default getCodeServices;
